import angular from "angular";
import UzivatelService from "./UzivatelService";
import UzivatelListCtrl from "./UzivatelListCtrl";
import UzivatelRoleCtrl from "./UzivatelRoleCtrl";

export default angular.module("energis.uzivatel", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("uzivatel-list", {
    url: "/uzivatelia",
    template: require("./uzivatel.list.html"),
    controller: UzivatelListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: (UzivatelService) => UzivatelService.listSource().wait(),
      odberatelia: (KontaktService) => KontaktService.listSource({limit: 1000}).wait().then(s => s.result)
    }
  })
  .state("uzivatel-role", {
    url: "/uzivatelia/role",
    template: require("./uzivatel.role.html"),
    controller: UzivatelRoleCtrl,
    controllerAs: "ctrl"
  })
})
.service("UzivatelService", UzivatelService)
.name;


// WEBPACK FOOTER //
// ./src/Uzivatel/index.js